export const CLEAR_CHAT_TOOLTIP =
  'Clears conversation history to save tokens on the next message. Your menu progress and uploaded model data are kept.';

export function buildAssistChatHistory(chatMessages) {
  return (chatMessages || []).map(({ role, text: msgText }) => ({
    role: role === 'ai' ? 'assistant' : role,
    text: msgText,
  }));
}

export function shouldConfirmChatClear(chatMessages, initialMessages) {
  return (chatMessages?.length || 0) > (initialMessages?.length || 0) + 1;
}

export function clearedChatMessages(initialMessages) {
  return [...(initialMessages || [])];
}
